import { render, staticRenderFns } from "./CoverageDetails.vue?vue&type=template&id=593b3ab4&"
import script from "./CoverageDetails.vue?vue&type=script&lang=js&"
export * from "./CoverageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports